import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

export function useApi(path, params) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const key = JSON.stringify(params || {});

  const load = useCallback(async () => {
    if (!path) { setData(null); setLoading(false); return; }
    setLoading(true);
    try {
      const res = await api.get(path, { params: JSON.parse(key) });
      setData(res.data);
    } catch (err) {
      if (err?.response?.status !== 401) {
        toast.error(formatApiError(err));
      }
    } finally {
      setLoading(false);
    }
  }, [path, key]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, reload: load };
}
